"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _RedPacketUploadImg = _interopRequireDefault(require("./RedPacketUploadImg"));
var _RedPacketCreatePrizePane = _interopRequireDefault(require("./RedPacketCreatePrizePane.vue"));
var _sys_cons = require("@/api/sys_cons");
var _red_packet = require("@/api/activity/red_packet");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RedPacketCreatePane',
  components: {
    RedPacketUploadImg: _RedPacketUploadImg.default,
    RedPacketCreatePrizePane: _RedPacketCreatePrizePane.default
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      loading: false,
      imageAccessDomain: '',
      // 图片访问域名
      memberLevelList: [],
      // 会员等级列表
      gagaAreaList: [],
      // gaga区域列表
      form: {
        title: '',
        // 活动标题
        subtitle: '',
        // 活动副标题
        activityTime: [],
        // 活动时间
        stock: 1,
        // 库存数量，初始值设为1
        enabled: false,
        // 是否启动，初始值设为false
        inviteCount: 5,
        // 邀请人数，初始值设为5
        cityRestriction: 1,
        // 城市限制，初始值设为1
        cityIds: [],
        // 城市ID列表
        headerImage: '',
        // 活动页头图
        bgColor: '',
        // 活动页背景色
        thirdLayerBgColor: '',
        // 第三层背景色
        redPacketCardFgColor: '',
        // 红包卡片前景色
        otherCardFgColor: '',
        // 其他卡片前景色
        cardTitleColor: '',
        // 卡片标题色
        redPacketNumColor: '',
        // 剩余红包数字颜色
        btnTextColor: '',
        // 按钮文字色
        btnBgColor: '',
        // 按钮背景色
        progressIcon: '',
        // 进度icon
        progressBarImage: '',
        // 进度条切图
        helperBackgroundImage: '',
        // 助力人背景图
        shareCardImage: '',
        // 分享卡片图
        posterImage: '',
        // 海报图
        redPacketPopupBg: '',
        // 领取红包弹窗背景图
        redPacketNumBgImg: '',
        // 剩余红包数字背景图
        ruleText: '',
        // 规则文本
        initiatorRestriction: 1,
        // 发起人会员等级限制
        initiatorGradeIds: [],
        // 发起人会员等级
        initiatorPrize: [],
        // 发起人奖励
        helperRestriction: 1,
        // 助力者会员等级限制
        helperGradeIds: [],
        // 助力者会员等级
        helperPrize: [] // 助力者奖励
      },
      rules: {
        title: [{
          required: true,
          message: '请输入活动标题',
          trigger: 'blur'
        }],
        subtitle: [{
          required: true,
          message: '请输入活动副标题',
          trigger: 'blur'
        }],
        stock: [{
          required: true,
          message: '请输入库存数量',
          trigger: 'blur'
        }],
        enabled: [{
          required: true,
          message: '请选择是否启动',
          trigger: 'change'
        }],
        inviteCount: [{
          required: true,
          message: '请输入邀请人数',
          trigger: 'blur'
        }],
        activityTime: [{
          required: true,
          message: '请选择活动时间',
          trigger: 'change'
        }],
        cityRestriction: [{
          required: true,
          message: '请选择城市限制',
          trigger: 'change'
        }],
        cityIds: [{
          required: true,
          message: '请选择城市ID列表',
          trigger: 'change'
        }],
        headerImage: [{
          required: true,
          message: '请上传活动页头图',
          trigger: 'blur'
        }],
        bgColor: [{
          required: true,
          message: '请输入活动页背景色',
          trigger: 'change'
        }],
        thirdLayerBgColor: [{
          required: true,
          message: '请输入第三层背景色',
          trigger: 'change'
        }],
        redPacketCardFgColor: [{
          required: true,
          message: '请输入红包卡片前景色',
          trigger: 'change'
        }],
        otherCardFgColor: [{
          required: true,
          message: '请输入其他卡片前景色',
          trigger: 'change'
        }],
        cardTitleColor: [{
          required: true,
          message: '请输入卡片标题色',
          trigger: 'change'
        }],
        redPacketNumColor: [{
          required: true,
          message: '请输入剩余红包数字颜色',
          trigger: 'change'
        }],
        btnTextColor: [{
          required: true,
          message: '请输入按钮文字色',
          trigger: 'change'
        }],
        btnBgColor: [{
          required: true,
          message: '请输入按钮背景色',
          trigger: 'change'
        }],
        progressIcon: [{
          required: true,
          message: '请上传进度icon',
          trigger: 'change'
        }],
        progressBarImage: [{
          required: true,
          message: '请上传进度条切图',
          trigger: 'change'
        }],
        helperBackgroundImage: [{
          required: true,
          message: '请上传助力人背景图',
          trigger: 'change'
        }],
        shareCardImage: [{
          required: true,
          message: '请上传分享卡片图',
          trigger: 'change'
        }],
        posterImage: [{
          required: true,
          message: '请上传海报图',
          trigger: 'change'
        }],
        redPacketPopupBg: [{
          required: true,
          message: '请上传领取红包弹窗背景图',
          trigger: 'change'
        }],
        redPacketNumBgImg: [{
          required: true,
          message: '请上传剩余红包数字背景图',
          trigger: 'change'
        }],
        ruleText: [{
          required: true,
          message: '请输入规则文本',
          trigger: 'blur'
        }],
        initiatorRestriction: [{
          required: true,
          message: '请选择发起人会员等级限制',
          trigger: 'change'
        }],
        initiatorGradeIds: [{
          required: true,
          message: '请选择发起人会员等级',
          trigger: 'change'
        }],
        initiatorPrize: [{
          required: true,
          message: '请输入发起人奖励',
          trigger: 'change'
        }],
        helperRestriction: [{
          required: true,
          message: '请选择助力者会员等级限制',
          trigger: 'change'
        }],
        helperGradeIds: [{
          required: true,
          message: '请选择助力者会员等级',
          trigger: 'change'
        }],
        helperPrize: [{
          required: true,
          message: '请输入助力者奖励',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    totalStockTip: function totalStockTip() {
      var totalStock = 0;
      if (this.form.initiatorPrize.length > 0) {
        for (var i = 0; i < this.form.initiatorPrize.length; i++) {
          totalStock += this.form.initiatorPrize[i].stock;
        }
      }
      if (this.form.helperPrize.length > 0) {
        for (var _i = 0; _i < this.form.helperPrize.length; _i++) {
          totalStock += this.form.helperPrize[_i].stock;
        }
      }
      return totalStock;
    }
  },
  watch: {
    'form.headerImage': function formHeaderImage(val) {
      this.$refs.form.validateField('headerImage');
    },
    'form.progressIcon': function formProgressIcon(val) {
      this.$refs.form.validateField('progressIcon');
    },
    'form.progressBarImage': function formProgressBarImage(val) {
      this.$refs.form.validateField('progressBarImage');
    },
    'form.helperBackgroundImage': function formHelperBackgroundImage(val) {
      this.$refs.form.validateField('helperBackgroundImage');
    },
    'form.shareCardImage': function formShareCardImage(val) {
      this.$refs.form.validateField('shareCardImage');
    },
    'form.posterImage': function formPosterImage(val) {
      this.$refs.form.validateField('posterImage');
    },
    'form.redPacketPopupBg': function formRedPacketPopupBg(val) {
      this.$refs.form.validateField('redPacketPopupBg');
    },
    'form.redPacketNumBgImg': function formRedPacketNumBgImg(val) {
      this.$refs.form.validateField('redPacketNumBgImg');
    }
  },
  created: function created() {
    this.getImageAccessDomain();
    this.getMemberLevelCombo();
    this.getGagaAreaCombo();
    // 初始化发起人奖励列表并添加一项
    this.form.initiatorPrize = [];
    this.addInitiatorPrize();

    // 初始化助力者奖励列表并添加一项
    this.form.helperPrize = [];
    this.addHelperPrize();
    if (this.id) {
      this.getRedPacketActivity();
    }
  },
  methods: {
    getRedPacketActivity: function getRedPacketActivity() {
      var _this = this;
      (0, _red_packet.queryRedPacketActivity)(this.id).then(function (res) {
        var data = res.data;
        if (data) {
          _this.form.title = data.title; // 活动标题
          _this.form.subtitle = data.subtitle; // 活动副标题
          _this.form.activityTime = data.activityTime; // 活动时间
          _this.form.stock = data.stock; // 库存数量
          _this.stock = data.stock; // 当前库存数量 修改只能增加不可以减少
          _this.form.enabled = data.enabled; // 是否启动
          _this.form.inviteCount = data.inviteCount; // 邀请人数
          _this.form.cityRestriction = data.cityRestriction; // 城市限制
          _this.form.cityIds = data.cityIds; // 城市ID列表
          _this.form.headerImage = data.headerImage; // 活动页头图
          _this.form.bgColor = data.bgColor; // 活动页背景色
          _this.form.thirdLayerBgColor = data.thirdLayerBgColor; // 第三层背景色
          _this.form.redPacketCardFgColor = data.redPacketCardFgColor; // 红包卡片前景色
          _this.form.otherCardFgColor = data.otherCardFgColor; // 其他卡片前景色
          _this.form.cardTitleColor = data.cardTitleColor; // 卡片标题色
          _this.form.redPacketNumColor = data.redPacketNumColor; // 剩余红包数字颜色
          _this.form.btnTextColor = data.btnTextColor; // 按钮文字色
          _this.form.btnBgColor = data.btnBgColor; // 按钮背景色
          _this.form.progressIcon = data.progressIcon; // 进度icon
          _this.form.progressBarImage = data.progressBarImage; // 进度条切图
          _this.form.helperBackgroundImage = data.helperBackgroundImage; // 助力人背景图
          _this.form.shareCardImage = data.shareCardImage; // 分享卡片图
          _this.form.posterImage = data.posterImage; // 海报图
          _this.form.redPacketPopupBg = data.redPacketPopupBg; // 领取红包弹窗背景图
          _this.form.redPacketNumBgImg = data.redPacketNumBgImg; // 剩余红包数字背景图
          _this.form.ruleText = data.ruleText; // 规则文本
          _this.form.initiatorRestriction = data.initiatorRestriction; // 发起人会员等级限制
          _this.form.initiatorGradeIds = data.initiatorGradeIds; // 发起人会员等级
          _this.form.initiatorPrize = []; // 发起人奖励
          if (data.initiatorPrize) {
            for (var i = 0; i < data.initiatorPrize.length; i++) {
              var prize = data.initiatorPrize[i];
              var item = {
                prizeType: prize.prizeType,
                couponId: prize.couponId,
                stock: prize.stock,
                couponCount: prize.couponCount,
                winRate: prize.winRate,
                integral: prize.integral
              };
              _this.form.initiatorPrize.push(item);
            }
          }
          _this.form.helperRestriction = data.helperRestriction; // 助力者会员等级限制
          _this.form.helperGradeIds = data.helperGradeIds; // 助力者会员等级
          _this.form.helperPrize = []; // 助力者奖励
          if (data.helperPrize) {
            for (var _i2 = 0; _i2 < data.helperPrize.length; _i2++) {
              var _prize = data.helperPrize[_i2];
              var _item = {
                prizeType: _prize.prizeType,
                couponId: _prize.couponId,
                stock: _prize.stock,
                couponCount: _prize.couponCount,
                winRate: _prize.winRate,
                integral: _prize.integral
              };
              _this.form.helperPrize.push(_item);
            }
          }
        }
      });
    },
    reset: function reset() {
      this.form.title = ''; // 活动标题
      this.form.subtitle = ''; // 活动副标题
      this.form.activityTime = []; // 活动时间
      this.form.stock = 1; // 库存数量，初始值设为1
      this.form.enabled = true; // 是否启动，初始值设为true
      this.form.inviteCount = 5; // 邀请人数，初始值设为5
      this.form.cityRestriction = 1; // 城市限制，初始值设为1
      this.form.cityIds = []; // 城市ID列表
      this.form.headerImage = ''; // 活动页头图
      this.form.bgColor = ''; // 活动页背景色
      this.form.thirdLayerBgColor = ''; // 第三层背景色
      this.form.redPacketCardFgColor = ''; // 红包卡片前景色
      this.form.otherCardFgColor = ''; // 其他卡片前景色
      this.form.cardTitleColor = ''; // 卡片标题色
      this.form.redPacketNumColor = ''; // 剩余红包数字颜色
      this.form.btnTextColor = ''; // 按钮文字色
      this.form.btnBgColor = ''; // 按钮背景色
      this.form.progressIcon = ''; // 进度icon
      this.form.progressBarImage = ''; // 进度条切图
      this.form.helperBackgroundImage = ''; // 助力人背景图
      this.form.shareCardImage = ''; // 分享卡片图
      this.form.posterImage = ''; // 海报图
      this.form.redPacketPopupBg = ''; // 领取红包弹窗背景图
      this.form.redPacketNumBgImg = ''; // 剩余红包数字背景图
      this.form.ruleText = ''; // 规则文本
      this.form.initiatorRestriction = 1; // 发起人会员等级限制
      this.form.initiatorGradeIds = []; // 发起人会员等级
      this.form.initiatorPrize = []; // 发起人奖励
      this.form.helperRestriction = 1; // 助力者会员等级限制
      this.form.helperGradeIds = []; // 助力者会员等级
      this.form.helperPrize = []; // 助力者奖励
      // 初始化发起人奖励列表并添加一项
      this.addInitiatorPrize();
      // 初始化助力者奖励列表并添加一项
      this.addHelperPrize();
    },
    submit: function submit() {
      var _this2 = this;
      console.log('submit');
      this.loading = true;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          (0, _red_packet.addRedPacketActivity)(_this2.form).then(function (res) {
            console.log('addRedPacketActivity', res);
            _this2.loading = false;
            _this2.$message.success('保存成功');
            _this2.$emit('toTable');
          }).catch(function (err) {
            console.log('addRedPacketActivity', err);
            _this2.loading = false;
          });
        } else {
          _this2.loading = false;
        }
      });
    },
    addHelperPrize: function addHelperPrize() {
      // 添加助力者一项奖励
      var prize = {
        prizeType: 1,
        couponId: '',
        stock: 0,
        couponCount: 0,
        winRate: 0,
        integral: 0
      };
      this.form.helperPrize.push(prize);
    },
    removeHelperPrize: function removeHelperPrize(idx) {
      // 移除助力者一项奖励
      this.form.helperPrize.splice(idx, 1);
    },
    removeInitiatorPrize: function removeInitiatorPrize(idx) {
      // 移除发起人一项奖励
      this.form.initiatorPrize.splice(idx, 1);
    },
    addInitiatorPrize: function addInitiatorPrize() {
      // 添加发起人一项奖励
      var prize = {
        prizeType: 1,
        couponId: '',
        stock: 0,
        couponCount: 0,
        winRate: 0,
        integral: 0
      };
      this.form.initiatorPrize.push(prize);
    },
    getImageAccessDomain: function getImageAccessDomain() {
      var _this3 = this;
      (0, _sys_cons.queryImageAccessDomain)().then(function (res) {
        _this3.imageAccessDomain = res.data || '';
      });
    },
    getMemberLevelCombo: function getMemberLevelCombo() {
      var _this4 = this;
      (0, _sys_cons.queryMemberLevelCombo)().then(function (res) {
        _this4.memberLevelList = res.data || [];
      });
    },
    getGagaAreaCombo: function getGagaAreaCombo() {
      var _this5 = this;
      (0, _sys_cons.queryGagaAreaCombo)().then(function (res) {
        _this5.gagaAreaList = res.data || [];
      });
    }
  }
};